<template>
  <!-- TAGLINE START-->
  <div class="tagline bg-slate-900">
    <div class="container relative">
      <div class="grid grid-cols-1">
        <div class="flex items-center justify-between">
          <ul class="list-none">
            <!-- <li class="inline-flex items-center">
              <Icon
                name="mdi-clock-outline"
                size="14px"
                class="text-red-500 size-4"
              />
              <span class="ms-2 text-slate-300">Mon-Sat: 9am to 6pm</span>
            </li> -->
            <li class="inline-flex items-center ms-2">
              <Icon
                name="mdi-map-marker-outline"
                class="text-red-500"
                size="14px"
              />
              <span class="ms-2 text-slate-300"
                >Batumi st. 16, Chakvi, Georgia</span
              >
            </li>
          </ul>

          <div class="list-none inline-flex items-center">
            <ul class="list-none inline-flex items-center">
              <li class="inline-flex items-center">
                <ul class="list-none inline-flex items-center space-x-1.5">
                  <li
                    v-for="(link, index) in SOCIAL_LINKS"
                    :key="index"
                    class="inline-flex items-center"
                  >
                    <template v-if="link.title === 'Email'">
                      <Icon
                        name="mdi-email-outline"
                        class="text-red-500"
                        size="14px"
                      />
                      <a
                        :href="`mailto:${config.public.contactEmail}`"
                        class="ms-2 text-slate-300 hover:text-slate-200"
                        >{{ config.public.contactEmail }}</a
                      >
                    </template>
                    <template v-else>
                      <a
                        :href="link.href"
                        :aria-label="link.title"
                        class="inline-flex items-center text-slate-300 hover:text-red-500"
                        ><Icon
                          :name="link.icon"
                          size="14px"
                          :title="link.title"
                      /></a>
                    </template>
                  </li>
                </ul>
                <!--end icon-->
              </li>
            </ul>
            <NavbarUtilityControls variant="dark" class="ml-6" />
          </div>
        </div>
      </div>
    </div>
    <!--end container-->
  </div>
  <!--end tagline-->
  <!-- TAGLINE END-->
</template>
<script setup lang="ts">
const config = useRuntimeConfig();
const SOCIAL_LINKS = useSocialLinks();
</script>
